import React, { useState, useEffect } from "react";
import {
  Box,
  SimpleGrid,
  Text,
  Heading,
  Divider,
  Container,
  VStack,
} from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import kr_img from "../Assets/kr_logo.png";
import sbc_img from "../Assets/sbc_logo.png";
import jb_img from "../Assets/jb_logo.png";
import pb_img from "../Assets/pb_logo.png";
import rj_img from "../Assets/rj_logo.png";
import lac_logo from "../Assets/lac_logo.png";
import cn_logo from "../Assets/CNPH.jpg";
import kt_logo from "../Assets/kantobar.png";
import gl_logo from "../Assets/General's Lechon Logo.jpg";
import NB from "../Components/Navbar/NavBar";
import { jwtDecode } from "jwt-decode";

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(28px) scale(0.94);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const fadeOutUp = keyframes`
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(-24px) scale(0.94);
  }
`;

const ALL_BRANDS = [
  { key: "KR",  path: "/kr",  img: kr_img,   alt: "Kenny Rogers Roasters",  label: "Kenny Rogers Roasters" },
  { key: "SBC", path: "/sbc", img: sbc_img,  alt: "Seattle's Best Coffee",  label: "Seattle's Best Coffee" },
  { key: "PB",  path: "/pb",  img: pb_img,   alt: "Paris Baguette",         label: "Paris Baguette" },
  { key: "RJ",  path: "/rj",  img: rj_img,   alt: "Ruby Jack's",            label: "Ruby Jack's" },
  { key: "LAC", path: "/lac", img: lac_logo, alt: "LA Chicks",              label: "LA Chicks" },
  { key: "CN",  path: "/cn",  img: cn_logo,  alt: "Christy Ng",             label: "Christy Ng" },
  { key: "KT",  path: "/kt",  img: kt_logo,  alt: "Kanto",                  label: "Kanto Bar & Grill" },
  { key: "GL",  path: "/gl",  img: gl_logo,  alt: "General's Lechon",       label: "General's Lechon" },
];

export default function Dashboard() {
  const [userRole, setUserRole] = useState([]);
  const [isExiting, setIsExiting] = useState(false);
  const navigate = useNavigate();

  const handleBrandClick = (path) => {
    setIsExiting(true);
    setTimeout(() => navigate(path), 450);
  };

  useEffect(() => {
    const decodeToken = () => {
      const token = document.cookie.replace(
        /(?:(?:^|.*;\s*)accessToken\s*=\s*([^;]*).*$)|^.*$/,
        "$1",
      );
      if (token) {
        const decodedToken = jwtDecode(token);
        return decodedToken;
      }
      return null;
    };

    const decodedToken = decodeToken();
    if (decodedToken) {
      const role = decodedToken.role;
      // SSO JWTs don't include the access claim; read from localStorage for both SSO and fallback logins
      const accessStr = localStorage.getItem('access') || '';
      const access = accessStr ? accessStr.split(',').filter(Boolean) : [];
      setUserRole(
        role === "admin"
          ? ["KR", "SBC", "JB", "PB", "RJ", "LAC", "CN", "KT", "GL"]
          : access,
      );
    }
  }, []);

  const visibleBrands = ALL_BRANDS.filter((b) => userRole.includes(b.key));

  return (
    <Box bg="gray.50" minH="100vh" display="flex" flexDirection="column">
      <NB />
      <Container maxW="1200px" py={12} px={{ base: 4, md: 8 }} flex="1">
        

        <SimpleGrid
          columns={{ base: 2, sm: 3, md: 4, lg: 4 }}
          spacing={{ base: 6, md: 10 }}
          justifyItems="center"
        >
          {visibleBrands.map((brand, index) => (
            <Box key={brand.key} onClick={() => handleBrandClick(brand.path)} cursor="pointer">
              <VStack
                spacing={3}
                role="group"
                sx={{
                  animation: isExiting
                    ? `${fadeOutUp} 0.4s ease both`
                    : `${fadeInUp} 0.9s ease both`,
                  animationDelay: isExiting ? "0s" : `${index * 0.12}s`,
                }}
              >
                <Box
                  w={{ base: "120px", sm: "150px", md: "180px" }}
                  h={{ base: "120px", sm: "150px", md: "180px" }}
                  borderRadius="full"
                  bg="white"
                  boxShadow="md"
                  p={4}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  transition="all 0.3s ease"
                  _groupHover={{
                    transform: "translateY(-6px)",
                    boxShadow: "xl",
                  }}
                >
                  <img
                    src={brand.img}
                    alt={brand.alt}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      borderRadius: "50%",
                    }}
                  />
                </Box>
                <Text
                  fontSize={{ base: "xs", sm: "sm" }}
                  fontWeight="600"
                  color="gray.600"
                  textAlign="center"
                  transition="color 0.2s"
                  _groupHover={{ color: "blue.500" }}
                >
                  {brand.label}
                </Text>
              </VStack>
            </Box>
          ))}
        </SimpleGrid>
      </Container>

      {/* Footer strip */}
      <Box bg="gray.100" borderTop="1px solid" borderColor="gray.200" py={4}>
        <Text textAlign="center" color="gray.400" fontSize="xs">
          © {new Date().getFullYear()} IT Department DBS &mdash; All rights reserved
        </Text>
      </Box>
    </Box>
  );
}
